<div class="fcp-error">
    <div class="fcp-error-icon-container">
        <fcp-icon class="fcp-error-icon" [icon]="['fal', iconName]"></fcp-icon>
    </div>
    <div class="fcp-error-text fcp-text-body-s">
        <ng-content></ng-content>
    </div>
</div>
